import { isUndefined } from 'lodash';
import { EntityAccountType } from 'src/models';

import { Maybe } from './types.utils';

export const getAccountApplicationGovernmentIdCategoryTitle = ({
  entityAccountType,
  index,
}: {
  entityAccountType?: EntityAccountType;
  index?: number;
}): Maybe<string> => {
  let result;

  if (entityAccountType?.isCorporate) {
    result = `Officer/Beneficial Owner`;
  }

  if (entityAccountType?.isLlc) {
    result = `Manager/Member/Beneficial Owner`;
  }

  if (entityAccountType?.isPartnership) {
    result = `Partner`;
  }

  if (entityAccountType?.isTrust) {
    result = `Trustee`;
  }

  if (!isUndefined(index) && !isUndefined(result)) {
    result = `${result} #${index + 1}`;
  }

  return result;
};
